import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import AdvantagesSection from './components/AdvantagesSection';
import ProductsSection from './components/ProductsSection';
import ReviewsSection from './components/ReviewsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'baoyu',
  url: 'https://bayo1u.github.io',
  description: 'baoyu 品牌官方落地页 - 以创新科技定义非凡体验，探索 baoyu 全系列产品、核心优势与用户口碑',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://bayo1u.github.io/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'baoyu',
  url: 'https://bayo1u.github.io',
  description: 'baoyu 致力于为全球用户提供卓越品质的产品与服务',
  sameAs: [
    'https://twitter.com/baoyu',
    'https://linkedin.com/company/baoyu',
  ],
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <main>
        <HeroSection />
        <AdvantagesSection />
        <ProductsSection />
        <ReviewsSection />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}